import { render, staticRenderFns } from "./EventsPage.vue?vue&type=template&id=32947304&scoped=true"
import script from "./EventsPage.vue?vue&type=script&lang=js"
export * from "./EventsPage.vue?vue&type=script&lang=js"
import style0 from "./EventsPage.vue?vue&type=style&index=0&id=32947304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32947304",
  null
  
)

export default component.exports